import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Admincardinaux.css';

const Admincardinaux = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    nomComplet: '',
    titreHonorifique: 'Son Éminence',
    dateNaissance: '',
    lieuNaissance: '',
    paysNaissance: '',
    paysService: '',
    continent: 'Europe',
    ordre: 'Cardinal-prêtre',
    nationalite: '',
    languesParlees: '',
    titre: '',
    dateCreation: '',
    creePar: '',
    formation: '',
    specialisation: '',
    biographie: '',
    photo: '',
    papabile: false,
    statutVotant: 'OUI'
  });
  
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [imageError, setImageError] = useState(false);
  
  // Image de fallback pour les cardinaux sans photo
  const defaultImage = '/images/cardinal-default.png';
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  
  const handleLanguesChange = (e) => {
    setFormData({
      ...formData,
      languesParlees: e.target.value.split(',').map(lang => lang.trim())
    });
  };
  
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      // Créer une prévisualisation
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
        setImageError(false);
      };
      reader.readAsDataURL(file);
    }
  };
  
  // Gestionnaire d'erreur pour les images
  const handleImageError = () => {
    console.log("Erreur de chargement d'image, utilisation de l'image par défaut");
    setImageError(true);
  };
  
  // Utiliser la route API pour les images avec le bon content-type
  const getApiImageUrl = (originalUrl) => {
    if (!originalUrl || imageError) return defaultImage;
    
    // Extraire le nom du fichier de l'URL
    const filename = originalUrl.split('/').pop().split('?')[0];
    
    // Ajouter un timestamp pour éviter le cache du navigateur
    const timestamp = new Date().getTime();
    return `/api/images/${filename}?t=${timestamp}`;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setMessage('');
    
    try {
      // Formater les données
      const cardinalData = {
        ...formData,
        nomComplet: `${formData.prenom} ${formData.nom}`
      };
      
      // Si une photo a été sélectionnée, l'uploader d'abord
      if (photoFile) {
        const formData = new FormData();
        formData.append('photo', photoFile);
        formData.append('nom', cardinalData.nom);
        formData.append('prenom', cardinalData.prenom);
        
        console.log("Envoi de la photo...");
        
        const uploadResponse = await axios.post('/api/upload/cardinal-photo', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        console.log("Réponse upload:", uploadResponse.data);
        
        // Ajouter l'URL de la photo au cardinal avec un timestamp pour éviter le cache
        const timestamp = Date.now();
        cardinalData.photo = `${uploadResponse.data.photoUrl}?v=${timestamp}`;
      }
      
      const response = await axios.post('/api/cardinaux', cardinalData);
      setMessage(`Cardinal ajouté avec succès: ${response.data.nomComplet}`);
      
      // Réinitialiser le formulaire
      setFormData({
        nom: '',
        prenom: '',
        nomComplet: '',
        titreHonorifique: 'Son Éminence',
        dateNaissance: '',
        lieuNaissance: '',
        paysNaissance: '',
        paysService: '',
        continent: 'Europe',
        ordre: 'Cardinal-prêtre',
        nationalite: '',
        languesParlees: '',
        titre: '',
        dateCreation: '',
        creePar: '',
        formation: '',
        specialisation: '',
        biographie: '',
        photo: '',
        papabile: false,
        statutVotant: 'OUI'
      });
      setPhotoFile(null);
      setPhotoPreview('');
      
      // Rediriger vers la liste après quelques secondes
      setTimeout(() => {
        navigate('/admin/cardinaux/liste');
      }, 2000);
    } catch (err) {
      setErrorMessage(`Erreur: ${err.response?.data?.msg || err.message}`);
    }
  };
  
  return (
    <div className="admin-page">
      <h1>Administration des Cardinaux</h1>
      
      {message && <div className="message success">{message}</div>}
      {errorMessage && <div className="message error">{errorMessage}</div>}
      
      <div className="admin-tabs">
        <div className="tab-header">
          <button className="tab-button active">Ajouter un cardinal</button>
          <Link to="/admin/cardinaux/liste" className="tab-button">Liste des cardinaux</Link>
        </div>
        
        <div className="tab-content">
          <form onSubmit={handleSubmit} className="cardinal-form">
            <div className="form-section">
              <h2>Informations personnelles</h2>
              
              <div className="form-group">
                <label>Prénom</label>
                <input 
                  type="text" 
                  name="prenom" 
                  value={formData.prenom} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label>Nom</label>
                <input 
                  type="text" 
                  name="nom" 
                  value={formData.nom} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label>Titre Honorifique</label>
                <input 
                  type="text" 
                  name="titreHonorifique" 
                  value={formData.titreHonorifique} 
                  onChange={handleChange} 
                />
              </div>
              
              <div className="form-group">
                <label>Date de naissance</label>
                <input 
                  type="date" 
                  name="dateNaissance" 
                  value={formData.dateNaissance} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label>Lieu de naissance</label>
                <input 
                  type="text" 
                  name="lieuNaissance" 
                  value={formData.lieuNaissance} 
                  onChange={handleChange} 
                />
              </div>
              
              <div className="form-group">
                <label>Pays de naissance</label>
                <input 
                  type="text" 
                  name="paysNaissance" 
                  value={formData.paysNaissance} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label>Pays de service</label>
                <input 
                  type="text" 
                  name="paysService" 
                  value={formData.paysService} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label>Continent</label>
                <select
                  name="continent"
                  value={formData.continent}
                  onChange={handleChange}
                  required
                >
                  <option value="Afrique">Afrique</option>
                  <option value="Amérique">Amérique</option>
                  <option value="Asie">Asie</option>
                  <option value="Europe">Europe</option>
                  <option value="Océanie">Océanie</option>
                </select>
              </div>
              
              <div className="form-group">
                <label>Nationalité</label>
                <input 
                  type="text" 
                  name="nationalite" 
                  value={formData.nationalite} 
                  onChange={handleChange} 
                />
              </div>
              
              <div className="form-group">
                <label>Langues parlées (séparées par des virgules)</label>
                <input 
                  type="text" 
                  name="languesParlees" 
                  value={formData.languesParlees} 
                  onChange={handleLanguesChange} 
                />
              </div>
              
              <div className="form-group">
                <label>Photo</label>
                <input 
                  type="file" 
                  name="photo" 
                  accept="image/*" 
                  onChange={handlePhotoChange} 
                />
                {photoPreview && (
                  <div className="photo-preview">
                    <img 
                      src={photoPreview} 
                      alt="Prévisualisation" 
                      onError={handleImageError}
                    />
                  </div>
                )}
              </div>
            </div>
            
            <div className="form-section">
              <h2>Informations cardinalices</h2>
              
              <div className="form-group">
                <label>Ordre</label>
                <select
                  name="ordre"
                  value={formData.ordre}
                  onChange={handleChange}
                  required
                >
                  <option value="Cardinal-évêque">Cardinal-évêque</option>
                  <option value="Cardinal-prêtre">Cardinal-prêtre</option>
                  <option value="Cardinal-diacre">Cardinal-diacre</option>
                </select>
              </div>
              
              <div className="form-group">
                <label>Titre</label>
                <input 
                  type="text" 
                  name="titre" 
                  value={formData.titre} 
                  onChange={handleChange} 
                />
              </div>
              
              <div className="form-group">
                <label>Date de création comme cardinal</label>
                <input 
                  type="date" 
                  name="dateCreation" 
                  value={formData.dateCreation} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label>Créé par (Pape)</label>
                <input 
                  type="text" 
                  name="creePar" 
                  value={formData.creePar} 
                  onChange={handleChange} 
                />
              </div>
              
              <div className="form-group">
                <label>Formation</label>
                <input 
                  type="text" 
                  name="formation" 
                  value={formData.formation} 
                  onChange={handleChange} 
                />
              </div>
              
              <div className="form-group">
                <label>Spécialisation</label>
                <input 
                  type="text" 
                  name="specialisation" 
                  value={formData.specialisation} 
                  onChange={handleChange} 
                />
              </div>
              
              <div className="form-group">
                <label>Biographie</label>
                <textarea 
                  name="biographie" 
                  value={formData.biographie} 
                  onChange={handleChange} 
                  rows="5"
                ></textarea>
              </div>
              
              <div className="form-group radio-group">
                <label>Statut Votant</label>
                <div className="radio-options">
                  <label>
                    <input
                      type="radio"
                      name="statutVotant"
                      value="OUI"
                      checked={formData.statutVotant === 'OUI'}
                      onChange={handleChange}
                    />
                    OUI
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="statutVotant"
                      value="NON"
                      checked={formData.statutVotant === 'NON'}
                      onChange={handleChange}
                    />
                    NON
                  </label>
                </div>
              </div>
              
              <div className="form-group checkbox">
                <label>
                  <input 
                    type="checkbox" 
                    name="papabile" 
                    checked={formData.papabile} 
                    onChange={handleChange} 
                  />
                  Considéré comme Papabile
                </label>
              </div>
            </div>
            
            <div className="form-actions">
              <button type="submit">Ajouter le Cardinal</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Admincardinaux;